(function () {
  console.log('✅ Infinity JS loaded', window.location.pathname);

  function $(sel) { return document.querySelector(sel); }

  function getCollectionBaseUrl() {
    // /collections/handle  (no query, no hash)
    return window.location.origin + window.location.pathname;
  }

  function getProductKey(cardEl) {
    const a = cardEl.querySelector('a[href*="/products/"]');
    if (a && a.getAttribute('href')) {
      try {
        const url = new URL(a.href, window.location.origin);
        url.search = '';
        url.hash = '';
        return url.pathname;
      } catch {
        return (a.getAttribute('href') || '').split('?')[0].split('#')[0];
      }
    }
    const pid =
      cardEl.getAttribute('data-product-id') ||
      cardEl.dataset?.productId ||
      cardEl.getAttribute('data-productid');
    if (pid) return `pid:${pid}`;
    return null;
  }

  function initInfinityOnce() {
    const grid = $('#product-grid');
    const pagination = $('#Pagination');
    const meta = $('#CollectionMeta');
    const status = $('#LoadMoreStatus');

    if (!grid || !pagination) return false;

    if (grid.dataset.infinityInit === '1') return true;
    grid.dataset.infinityInit = '1';

    const totalProducts = meta ? parseInt(meta.dataset.totalProducts || '0', 10) : 0;

    const sentinel = $('#InfinitySentinel');
    const btn = $('#LoadMoreBtn');
    const mode = sentinel ? 'auto_load' : (btn ? 'load_more' : 'pagination');
    if (mode === 'pagination') return true;

    let loading = false;
    let currentPage = parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
    const baseUrl = getCollectionBaseUrl();

    const seenPages = new Set();
    const loadedKeys = new Set();

    function setStatus(t) {
      if (status) status.textContent = t || '';
    }

    function stop(message) {
      setStatus(message || 'No more products.');
      console.log('[Infinity] stopped:', message || 'No more products.');
    }

    // existing products register
    [...grid.querySelectorAll('.grid__item')].forEach(el => {
      const k = getProductKey(el);
      if (k) loadedKeys.add(k);
    });

    console.log('[Infinity] init ok:', {
      mode,
      totalProducts,
      loadedNow: loadedKeys.size,
      currentPage,
      baseUrl
    });

    function buildPageUrl(pageNum) {
      const u = new URL(baseUrl, window.location.origin);
      u.searchParams.set('page', String(pageNum));
      return u.toString();
    }

    async function loadNext() {
      if (loading) return;

      if (totalProducts && loadedKeys.size >= totalProducts) {
        stop('No more products.');
        return;
      }

      const nextPage = currentPage + 1;

      if (seenPages.has(nextPage)) {
        stop('No more products.');
        return;
      }
      seenPages.add(nextPage);

      const nextUrl = buildPageUrl(nextPage);

      loading = true;
      setStatus('Loading...');
      console.log('[Infinity] fetching:', nextUrl);

      try {
        const res = await fetch(nextUrl, { credentials: 'same-origin' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newGrid = doc.querySelector('#product-grid');
        const newPagination = doc.querySelector('#Pagination');

        let added = 0;

        if (newGrid) {
          const items = [...newGrid.querySelectorAll('.grid__item')];

          items.forEach(item => {
            const key = getProductKey(item);
            if (!key) return;

            if (!loadedKeys.has(key)) {
              if (totalProducts && loadedKeys.size >= totalProducts) return;

              loadedKeys.add(key);
              grid.appendChild(item);
              added++;
            }
          });
        }

        if (newPagination) pagination.innerHTML = newPagination.innerHTML;

        console.log('[Infinity] added:', added, 'loaded:', loadedKeys.size, 'nextPage:', nextPage);

        if (added === 0) {
          stop('No more products.');
          return;
        }

        currentPage = nextPage;

        if (totalProducts && loadedKeys.size >= totalProducts) {
          stop('No more products.');
          return;
        }

        setStatus('');
      } catch (e) {
        console.error('[Infinity] error:', e);
        setStatus('Failed to load. Try again.');
      } finally {
        loading = false;
      }
    }

    if (mode === 'load_more' && btn) {
      btn.addEventListener('click', loadNext);
    }

    function onScroll() {
      const nearBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 900;
      if (nearBottom) loadNext();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(onScroll, 400);

    return true;
  }

  let tries = 0;
  const maxTries = 60;
  const timer = setInterval(() => {
    tries++;
    const ok = initInfinityOnce();
    if (ok || tries >= maxTries) clearInterval(timer);
  }, 250);

  const mo = new MutationObserver(() => {
    const grid = $('#product-grid');
    const pagination = $('#Pagination');
    if (!grid || !pagination) return;

    if (grid.dataset.infinityInit !== '1') {
      initInfinityOnce();
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();